import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Notify browser that initial rendering is about to happen
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    bootstrapApplication(AppComponent, appConfig)
      .catch((err) => console.error(err));
  });
} else {
  bootstrapApplication(AppComponent, appConfig)
    .catch((err) => console.error(err));
}
